import React, { useEffect, useState } from "react";
import ReactLineChart from "../../sharedComponents/reactLineChart";

export default function ProgressWeightDetailChart({ stackedWeightDetails }) {
	useEffect(() => {
		trimChartData(stackedWeightDetails);
	}, [stackedWeightDetails]);

	const [chartData, setChartData] = useState({});

	const trimChartData = (stackedWeightDetails) => {
		if (stackedWeightDetails && stackedWeightDetails.length) {
			const data_series = stackedWeightDetails;
			const data_categories = [];
			stackedWeightDetails.forEach((item, index) => {
				if (index === 0) {
					item.data.map((item2) => data_categories.push(item2.x));
				}
			});
			setChartData({
				data_categories,
				data_series
			});
		}
	};

	const renderChartLegends = () => {
		if (chartData && chartData.data_series && chartData.data_series.length) {
			return <div className="legends-wrap">
				{chartData.data_series.map(({ color, name, data }, index) => {
					return data && data.length ? <div className="legend" key={index}>
						<div className="legend-color" style={{ backgroundColor: color }} />
						<div className="legend-name">{name}</div>
					</div> : null;
				})}
			</div>
		}
		return null;
	}

	return (
		<div className="card card-primary w-100 h-100 m-0 p-4 border-0 featured-recipes-list">
			<h4 className="text-primary-dark">Weight Detail Chart</h4>
			<div className="pt-3 last-child-b-0">
				<div>{renderChartLegends()}</div>
				<ReactLineChart data={chartData} height={40} />
			</div>
		</div>
	);
}
